<template>
    <div>
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <ots-refer
            class="mb20"
            :selectList="selectList"
            :request-form="stuSelectParams"
            @search="getStudentList"
        />
        <div class="mainCon">
            <ots-table-group
                :tableHeader="tableHeader"
                :tableData="tableData"
                :pagination="pagination"
                @changeNum="changeSize"
                @changePage="changePage"
            ></ots-table-group>
        </div>
    </div>
</template>
<script>
import { getPlanCourseFn } from '@/http/modules/baseSet/course';
import { getStudentScoreListFn, getOtsUrlFn, exportStudentScoreFn } from '@/http/modules/examSet/score';
import { getSelectPlanFn } from '@/http/modules/examSet/examBatch'
const photoState = {
    0: '未通过',
    1: '通过',
    2: '-'
}
export default {
    name: '',
    data () {
        return {
            mainTopBtnList: [
                {
                    title: '导出',
                    fn: this.exportScore
                }
            ],
            selectList: [
                {
                    title: "考试批次",
                    type: "select",
                    requestKey: "planId",
                    label: 'name',
                    value: 'id',
                    data: [],
                },
                {
                    title: "函授站",
                    type: "select",
                    requestKey: "stationId",
                    isSearch: true,
                    multiple: true,
                    label: 'name',
                    value: 'id',
                    data: [],
                },
                {
                    title : '关键词',
                    type : 'input',
                    placeholder : '姓名/准考证号/证件号',
                    requestKey: "searchKey"
                },
                {
                    title: "课程",
                    type: "select",
                    requestKey: "courseId",
                    label: 'courseName',
                    value: 'courseId',
                    data: [],
                },
            ],
            stuSelectParams: {
                planId: '',
                courseId: '',
                searchKey: '',
                stationId: ['']
            },
            stuListParams: {
                page: 1,
                size: 10,
            },
            tableHeader: [
                {
                    title: "考试批次",
                    prop: "planName",
                    fixed: "left",
                    width: "120"
                },
                {
                    title:"姓名",
                    prop: "realName",
                    fixed: "left"
                },
                {
                    title:"准考证号",
                    prop: "entranceCode",
                    fixed: "left",
                    width: "120"
                },
                {
                    title: "证件号",
                    prop: "cardNo",
                    fixed: "left",
                    width: "120"
                },
                {
                    title: '函授站',
                    prop: 'stationName'
                },
                {
                    title: "考点",
                    prop: "placeName"
                },
                {
                    title: '分数',
                    prop: 'score'
                },
                {
                    title:"成绩",
                    prop: "publishResult",
                    // formatter: (val) => val.row.classSetStudent == 1 ? '已安排' : '未安排',
                },
                {
                    title:"人脸验证状态",
                    prop: "photoCheckState",
                    formatter: (val) => photoState[val.row.photoCheckState] || '数据错误',
                },
                {
                    title: "人脸验证审核状态",
                    prop: "humanAuditState"
                },
                {
                    title:"考试状态",
                    prop: "checkState",
                },
                {
                    title: "考试课程",
                    prop: "courseName",
                    fixed: "right",
                },
                {
                    title:"发布状态",
                    prop: "placeNames",
                    fixed: "right",
                    formatter: (val) => val.row.scorePublish == 1 ? '已发布' : '未发布',
                },
                {
                    title:"作答详情",
                    type: 'button',
                    fixed: "right",
                    formatter: () => '查看',
                    disableFn: (val) => val.row.publishResult  == '-' || val.row.checkState=='缺考' ? true : false,
                    click: this.goOTS
                },
            ],
            tableData: [],
            pagination: {
                total: 0
            },
            customSearch: [],
        }
    },
    watch: {
        'stuSelectParams.planId': function(val) {
            /* *** 批次变化, 重置课程 *** */
            this.initCourseList(val);
            /* *** 批次变化,重新搜索 *** */
            this.getStudentList();
        }
    },
    created () {
        this.initData()
    },
    methods: {
        /**************************
         * @initData 初始化表单数据
         *************************/
        async initData () {
            /* *** 考试批次列表(成绩已发布) *** */
            this.mixin_getSelectPlan().then(res => {
                let planList = [{id: '', name: '全部'}, ...res];
                this.$set(this.selectList[0], 'data', planList);
                this.stuSelectParams.planId = res[0].id;
            })

            /* *** 函授站列表 *** */
            this.mixin_getSelectStation().then((data) => {
                let newStationList = [ {id: "", name: "全部"}, ...data ];
                this.$set(this.selectList[1], 'data', newStationList)
            })
            
            /* *** 自动配置自定义字段搜索表单, table 表格自定义列 *** */
            this.mixin_setUserExtInfo().then(res => {
                let TypeList = ['select', 'province', 'subject', 'nation', 'politicalStatus', 'level'];
                res.data.map( item => {
                    if (item.queryCondition == 1){
                        if (TypeList.includes(item.type)) {
                            if ( item.valueVo ) {
                                let search = {
                                    title: item.displayName,
                                    type: 'select',
                                    requestKey: item.name,
                                    label: 'name',
                                    value: 'name',
                                    data: [ { name: "全部" }, ...item.valueVo ],
                                };      
                                this.customSearch.push(search);                         
                            }
                        } else if (item.type == 'text') {
                            let search = {
                                title: item.displayName,
                                type: 'input',
                                requestKey: item.name,
                                placeholder: '请输入',
                            };
                            this.customSearch.push(search);     
                        } else if (item.type == 'provinceCity') {
                            let search = {
                                title: item.displayName,
                                type: 'cascader',
                                requestKey: item.name,
                                label: 'name',
                                value: 'name',
                                data: [ { name: "全部" }, ...item.valueVo ],
                            };  
                            this.customSearch.push(search);             
                        }
                    }
                    // table 表格数据
                    if (item.type == 'imageUpload') {
                        let tables = {
                            title: item.displayName,
                            type: 'img',
                            width: "120",
                            prop: item.name,
                        }
                        this.tableHeader.splice(6,0,tables);
                    } else {
                        let tables = {
                            title: item.displayName,
                            width: "120",
                            prop: item.name,
                        }   
                        this.tableHeader.splice(6,0,tables);
                    };
                });
                this.stuSelectParams = Object.assign(this.stuSelectParams, res.requestForm);
                this.selectList = [...this.selectList,...this.customSearch];
            })
        },

        /*********************************
         * @initCourseList 课程随着批次变化
         ********************************/
        async initCourseList(val){
            /* *** 根据批次获取课程 *** */
            this.stuSelectParams.courseId = ''
            const { data: courseData } = await getPlanCourseFn({planId: val})
            this.selectList[3].data = courseData
        },
        changeSize(num) {
            this.stuListParams.size=num
            this.getStudentList()
        },
        changePage(p) {
            this.stuListParams.page=p
            this.getStudentList(true)
        },
        /********************************
         * @getStudentList 获取考生列表
         *******************************/
        async getStudentList (page) {
            let params
            if (!page) {
                this.stuListParams.page = 1
                params = Object.assign(this.stuListParams, this.stuSelectParams)
            } else {
                params = Object.assign(this.stuTempParams, {page: this.stuListParams.page})
            }
            /* *** 修改函授站可多选, 当前 typeOf(stationId) object *** */
            if (typeof(params.stationId) == 'object') {
                params.stationId = params.stationId.join(',');
            }
            /* ** 自定义字段 - 层次 "全部" 选项处理 */
            for (let key in params) {
                params[key] = params[key] == '全部' ? '' : params[key];
            }
            const { data } = await getStudentScoreListFn(params);
            this.stuTempParams = params;
            this.tableData = data.records;
            this.pagination.total = data.total;
            data.records.forEach((e) => {
                e.extData.forEach((item) => {
                    e[item.name] = item.value;
                });
            });
        },
        async goOTS (row) {
            let params = {
                action: 'getTReviewDetails',
                parames: `argumentsId=${row.recordId}&curPage=JudgeLib`
            }
            const { code, data } = await getOtsUrlFn(params)
            if (code==1) {
                window.open(data)
            }
        },
        exportScore() {
            let params = { ...this.stuSelectParams };
            params.stationId = params.stationId.join();
            exportStudentScoreFn(params).then((res) => {
                if(res.code == 1) {
                    window.open(res.data)
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
</style>